export const money = cents => cents !== null && cents !== undefined && Number.isSafeInteger(Number(cents)) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(cents) / 100) : '—'
export const amount = cents => (Number(cents) / 100).toFixed(2)
export const cents = value => {
  if (!/^\d+(\.\d{1,2})?$/.test(String(value))) return null
  const result = Math.round(Number(value) * 100)
  return Number.isSafeInteger(result) ? result : null
}
export const easternToday = (now = new Date()) => new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).format(now)
const iso = date => date.toISOString().slice(0, 10)
export function quickDates(view, now = new Date()) {
  const today = easternToday(now)
  const date = new Date(`${today}T12:00:00Z`)
  if (view === 'Today') return { date_from: today, date_to: today }
  if (view === 'This Month') return { date_from: `${today.slice(0, 7)}-01`, date_to: today }
  const monday = new Date(date); monday.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 6) % 7)
  if (view === 'This Week') return { date_from: iso(monday), date_to: today }
  const sunday = new Date(monday); sunday.setUTCDate(sunday.getUTCDate() - 1)
  monday.setUTCDate(monday.getUTCDate() - 7)
  return { date_from: iso(monday), date_to: iso(sunday) }
}
export const methods = ['Check', 'Credit Card', 'Zelle', 'Wire Transfer', 'Cash']
